import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const LeadFilters = ({ 
  searchTerm, 
  setSearchTerm, 
  statusFilter, 
  setStatusFilter,
  dateRange,
  setDateRange,
  onReset 
}) => {
  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'pending', label: 'Pending' },
    { value: 'qualified', label: 'Qualified' },
    { value: 'contacted', label: 'Contacted' },
    { value: 'closed-won', label: 'Closed Won' },
    { value: 'closed-lost', label: 'Closed Lost' },
    { value: 'nurturing', label: 'Nurturing' },
  ];

  const dateRangeOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
    { value: 'quarter', label: 'This Quarter' },
    { value: 'year', label: 'This Year' },
  ];

  return (
    <div className="bg-card rounded-lg border border-border elevation-1 p-6 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="lg:col-span-2">
          <Input
            type="search"
            placeholder="Search by customer name, email, or Salesforce ID..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e?.target?.value)}
          />
        </div>
        <Select
          options={statusOptions}
          value={statusFilter}
          onChange={setStatusFilter}
          placeholder="Filter by status"
        />
        <Select
          options={dateRangeOptions}
          value={dateRange}
          onChange={setDateRange}
          placeholder="Filter by date"
        />
      </div>
      {(searchTerm || statusFilter !== 'all' || dateRange !== 'all') && (
        <div className="mt-4 flex items-center justify-between">
          <p className="text-sm text-muted-foreground">
            Active filters applied
          </p>
          <Button 
            variant="ghost" 
            size="sm" 
            iconName="X" 
            iconPosition="left"
            onClick={onReset}
          >
            Clear Filters
          </Button>
        </div>
      )}
    </div>
  );
};

export default LeadFilters;